import './styles.scss';

import questionHelp from '../../../../images/question-help.svg';

import React, {CSSProperties} from 'react';

import useZendesk from '../../../hooks/useZendesk';
import {CURRENT_YEAR} from '../../../utils/DateUtil';

type AppFooterProps = {
    style?: CSSProperties;
};

export const AppFooter = ({style}: AppFooterProps) => {
    const {activateZendesk} = useZendesk();

    return (
        <footer className='app-footer' style={style}>
            <div className='app-footer__copyright' role='region'>
                © <span>{CURRENT_YEAR}</span> Kashable. All Rights Reserved.
            </div>
            <div className='app-footer__support' role='region'>
                <a href='mailto:support@kashable.com'>support@kashable.com</a>
            </div>
            <div className='app-footer__phone' role='region'>
                <a href='tel:+16466634353'>+1 (646) 663‑4353</a>
            </div>
            <div className='app-footer__help' role='region' >
                <button className='help-button' data-testid='open_zendesk' id='open_zendesk' onClick={activateZendesk}>
                    <img className='help-button__img' src={questionHelp} alt='help' />
                    <span className='help-button__text'>Help</span>
                </button>
            </div>
        </footer>
    );
};
